
if (navigator.share && document.querySelector('.share__link--email')) {
    document.querySelector('.share__link--email').addEventListener('click', function (event) {
        event.preventDefault();
        navigator.share({ url: window.location.href }).catch(function () {})
    });
}
